import { Grid, Slide } from '@material-ui/core'
/* eslint-disable import/order */
/* eslint-disable import/extensions */
import AppBar from '@material-ui/core/AppBar'
import Dialog from '@material-ui/core/Dialog'
import IconButton from '@material-ui/core/IconButton'
import withStyles from '@material-ui/core/styles/withStyles'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import React from 'react'
import { useDispatch } from 'react-redux'

import styles from '../../../resources/theme/global'
import { post } from '../BillingTypeActions'
import Form from './Form'
import BaseFilterModal from '../../../components/hooks/BaseFilterModal'
import colors from '../../../assets/colors'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />
})

function NewBillingType(props) {
  const { classes } = props
  const dispatch = useDispatch()
  const history = useHistory()

  const onSubmit = values => {
    dispatch(post(values)).then(data => {
      if (data && data.code === 200) {
        onClose()
      }
    })
  }

  const onClose = () => {
    history.goBack()
  }

  return (
    <BaseFilterModal open handleOpen={onClose} title="Novo Tipo de conta">
      <Grid
        container
        alignItems="center"
        item
        xs={12}
        justifyContent="flex-start"
        style={{ width: '420px' }}
        spacing={1}
      >
        <Grid item xs={12}>
          <Typography
            style={{ fontSize: '16px', fontWeight: 'normal' }}
            color={colors.primary}
          >
            Utilize os campos para cadastrar um tipo de conta
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Form classes={classes} onClose={onClose} onSubmit={onSubmit} />
        </Grid>
      </Grid>
    </BaseFilterModal>
  )
}

export default withStyles(styles)(NewBillingType)
